import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { apiRequest } from '@cancercentrum/inca';
import usePromise from '../../hooks/usePromise';
import { AjaxErrorAlert } from '../AjaxErrorAlert';
import { LoadingAlert } from '../LoadingAlert';
import ErrorBoundary from '../ErrorBoundary';
import { createCustomPageContext } from './utils';
import { IncaContext } from './IncaContext';
export const ScopedCustomPage = (props)=>{
    const { children, shortname } = props;
    const { isLoading, error, result, exec } = usePromise();
    useEffect(()=>{
        exec(async ()=>{
            const currentUser = await apiRequest('/Users/Current');
            return createCustomPageContext({
                currentUser,
                shortname
            });
        });
    }, [
        shortname,
        exec
    ]);
    if (error) {
        return /*#__PURE__*/ _jsx(AjaxErrorAlert, {
            error: error
        });
    }
    if (isLoading || !result) {
        return /*#__PURE__*/ _jsx(LoadingAlert, {});
    }
    return(// @ts-ignore oklart
    /*#__PURE__*/ _jsx(ErrorBoundary, {
        children: /*#__PURE__*/ _jsx(IncaContext.Provider, {
            value: result,
            children: children
        })
    }));
};
